import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useApiTranslation = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'apiMessage' });

  const apiT = useCallback(
    (key: string) => {
      return t(key, {
        nsSeparator: '###',
        defaultValue: key,
      });
    },
    [t]
  );

  return { apiT };
};
